<div class="modal-header">
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <p [innerHTML]="message | translate: { value: parameter }"></p>
</div>

<div class="modal-footer">
    @switch (assignedModalType) {
        @case (informativeModalType.Question) {
            <button type="button" id="secondary" class="btn btn-secondary" (click)="dismissModal()">
                {{ 'CANCEL' | translate }}
            </button>
            <button type="button" id="primary" class="btn btn-primary" (click)="confirmModal()">
                {{ 'YES' | translate }}
            </button>
        }
        @case (informativeModalType.Warning) {
            <button type="button" id="secondary" class="btn btn-primary" (click)="confirmModal()">
                {{ 'YES' | translate }}
            </button>
            <button type="button" id="primary" class="btn btn-secondary" (click)="dismissModal()">
                {{ 'CANCEL' | translate }}
            </button>
        }
        @case (informativeModalType.Error) {
            <button type="button" id="primary" class="btn btn-primary" (click)="dismissModal()">
                {{ 'CLOSE' | translate }}
            </button>
        }
        @case (informativeModalType.OK) {
            <button type="button" id="primary" class="btn btn-primary ml-auto" (click)="confirmModal()">
                OK
            </button>
        }
    }
</div>
